/*! @azure/msal-browser v2.38.1 2023-08-07 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.38.1";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
